const DEFAULT_API_BASE_URL = 'http://localhost:8000';

export const API_BASE_URL = (process.env.REACT_APP_API_URL || DEFAULT_API_BASE_URL).replace(/\/+$/, '');

export const GOOGLE_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_CLIENT_ID ||
  '419194657672-mc1t9im9q1s4mmdhj4bfi9jrahbct05j.apps.googleusercontent.com';

export const apiUrl = (path = '') => {
  if (!path) {
    return API_BASE_URL;
  }

  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }

  return `${API_BASE_URL}${path.startsWith('/') ? path : `/${path}`}`;
};

const extractStoragePath = (value = '') => {
  if (!value) {
    return '';
  }

  const trimmedValue = value.trim();

  if (/^https?:\/\//i.test(trimmedValue)) {
    try {
      const parsed = new URL(trimmedValue);
      const publicObjectMatch = parsed.pathname.match(/\/storage\/v1\/object\/public\/[^/]+\/(.+)$/i);

      if (publicObjectMatch?.[1]) {
        return decodeURIComponent(publicObjectMatch[1]);
      }

      const mediaMatch = parsed.pathname.match(/\/media\/(.+)$/i);
      if (mediaMatch?.[1]) {
        return decodeURIComponent(mediaMatch[1]);
      }
    } catch (error) {
      return '';
    }
  }

  if (trimmedValue.startsWith('/media/')) {
    return trimmedValue.replace(/^\/media\//i, '');
  }

  if (trimmedValue.startsWith('media/')) {
    return trimmedValue.replace(/^media\//i, '');
  }

  if (!trimmedValue.startsWith('/')) {
    return trimmedValue;
  }

  return '';
};

export const fileUrl = (path = '') => {
  if (!path) {
    return '';
  }

  const storagePath = extractStoragePath(path);

  if (storagePath) {
    return apiUrl(`/api/media-file/?path=${encodeURIComponent(storagePath)}`);
  }

  return apiUrl(path);
};
